module.exports = __webpack_public_path__ + "img/still-notes-small.24ed03da.png";